// The support contact the caiet requires on every page — ACCS-10, "toate paginile
// web trebuie să includă date de contact pentru suport". Shaped after the wireframe
// subsol (`wireframes/react/src/components/Shell.tsx:224-244` and its
// `styles/mud.css:5755` "Compact MUD support row", read-only): the AMDM mark and the
// SIMSM identity on the left, three plain links on the right, and nothing beneath.
// Rendered by `AppShell` on every authenticated route and by `PublicShell` on every
// anonymous one.
import { useTranslate } from '@tolgee/react';
import { MudLink } from '@egov-moldova/mud-react';

// Why no AGE footer component. MUD 1.2 ships none; the AGE one it replaced rendered a
// legal bar in its `simple` branch and silently discarded the `contact` it accepted,
// and its `evo` branch measured 531px against the single 56px row the wireframe
// draws. Neither matters any more: the wireframe's subsol has no legal bar at all,
// and the caiet asks only for a support contact (ACCS-10), not a copyright line — so
// there is nothing left for a footer component to render here. The row below is
// MUD primitives (`mud-link`) over MUD tokens: no fork, no new token.
//
// The version and build string went with the legal bar. If support needs it back, it
// belongs somewhere the wireframe has a place for, not appended to a bar the design
// does not draw.

export function Footer(): JSX.Element {
  const { t } = useTranslate();
  const email = t('footer.contact.email');

  return (
    // eslint-disable-next-line no-restricted-syntax -- MUD 1.2 ships no footer (gap): the AGE footer it replaced always rendered a legal bar the wireframe does not draw, and its `evo` variant measured 531px against the design's 56px row; neither could be reshaped from outside the shadow boundary
    <footer className="simsm-footer" aria-label={t('footer.aria_label')}>
      <div className="simsm-footer__row">
        <div className="simsm-footer__brand">
          <img src="/brand/amdm-mark.png" alt="" width={32} height={32} />
          <div className="simsm-footer__brand-text">
            <span className="simsm-footer__brand-mark">{t('home.product.mark')}</span>
            <span className="simsm-footer__brand-name">{t('footer.product.name')}</span>
          </div>
        </div>

        <nav className="simsm-footer__links" aria-label={t('footer.links.aria_label')}>
          {/* Three plain links, no prefix label and no raw address: the wireframe's
              first link reads "Suport tehnic" and carries the mailto behind it
              (wireframes/react/src/components/Shell.tsx:231). The address itself is
              still the href, so ACCS-10's support contact is on every page. */}
          <MudLink href={`mailto:${email}`} size="md" variant="strict" underline="hover">
            {t('footer.link.support_tech')}
          </MudLink>
          <MudLink
            href="https://support.amdm.gov.md"
            target="_blank"
            size="md"
            variant="strict"
            underline="hover"
          >
            {t('footer.link.support_portal')}
          </MudLink>
          <MudLink
            href="https://amdm.gov.md"
            target="_blank"
            size="md"
            variant="strict"
            underline="hover"
          >
            {t('footer.link.amdm')}
          </MudLink>
        </nav>
      </div>
    </footer>
  );
}
